<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'BARBER JOHNSON' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-11">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-1 pt-1 pl-0">
                <button class="btn btn-primary mt-4 btn-block" @click="apply">
                  Apply
                </button>
              </div>
            </div>
          </div>
          <div v-if="loaded">
            <div class="py-4" v-if="scatterData || pieData || barData">
              <div class="row mb-4">
                <div class="col-md-9">
                  <h4 class="py-2">
                    Menampilkan Barber Johnson
                    {{
                      formSet.dari
                        ? formSet.sampai
                          ? `periode ${formSet.dari} sampai ${formSet.sampai}:`
                          : `sejak ${formSet.dari} sampai saat ini`
                        : formSet.sampai
                        ? `sampai periode ${formSet.sampai}`
                        : ``
                    }}
                    <!-- periode {{ formSet.dari }} sampai {{ formSet.sampai }} -->
                  </h4>
                </div>
                <div class="col-md-3">
                  <a
                    @click="print"
                    class="btn btn-outline-secondary btn-with-icon-left"
                  >
                    <i class="material-symbols-outlined">cloud_download</i>
                    Download Laporan
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card" style="height: 100%">
                    <div class="row">
                      <div class="col-md-12 py-4 px-5">
                        <div v-if="scatterData" style="position: relative">
                          <h3 class="text-center mt-3 mb-4">Barber Johnson</h3>
                          <scatter-chart
                            :chart-data="scatterData"
                            :options="{
                              maintainAspectRatio: false,
                              scales: {
                                xAxes: [
                                  {
                                    type: 'linear',
                                    position: 'bottom',
                                    scaleLabel: {
                                      display: true,
                                      labelString: 'Turnover Interval (days)',
                                    },
                                  },
                                ],
                                yAxes: [
                                  {
                                    scaleLabel: {
                                      display: true,
                                      labelString:
                                        'Average Length of Stay (days)',
                                    },
                                  },
                                ],
                              },
                            }"
                          ></scatter-chart>
                        </div>
                        <div v-else>
                          <EmptyState
                            :data="{
                              img: '/img/chart.svg',
                              title: 'Tidak ada data di sini',
                              content:
                                'Tidak ada grafik data penyakit menular di sini',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-4" v-else>
              <EmptyState
                :data="{
                  img: '/img/chart.svg',
                  title: 'Tampilkan grafik di sini',
                  content: 'Terapkan filter di atas untuk menampilkan grafik',
                  size: 'medium mb-0',
                }"
              />
            </div>
          </div>
          <Loading v-else />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
// import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import ScatterChart from "@/components/ScatterChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  tabs,
  filtersRujukan,
  sort,
  upperTabs,
  singleSelectRujukan,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRujukan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    // DoughnutChart,
    // BarChart,
    // HorizontalBarChart,
    ScatterChart,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      chartStyles: { height: "25vw", position: "relative" },
      pieData: null,
      barData: null,
      scatterData: null,
      loaded: true,
      data: data,
      filters: filtersRujukan,
      sort: sort,
      tabs: tabs,
      upperTabs: upperTabs,
      total: 0,
      diffDays: 0,
      formSet: {
        dari: "",
        sampai: "",
      },
      single_select: null,
    };
  },
  methods: {
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      //console.log(this.formSet);
      // await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
      // this.apply();
    },
    print: function() {
      window.print();
    },
    fillData: async function() {
      this.pieData = {
        labels: ["Laki-laki", "Perempuan"],
        datasets: [
          {
            label: "",
            backgroundColor: ["#097CEB", "#e52e6b"],
            data: [this.getRandomInt(), this.getRandomInt()],
          },
        ],
      };

      this.barData = {
        labels: [
          "<1 Tahun",
          "1-4 Tahun",
          "5 -14 Tahun",
          "15-44 Tahun",
          "45 - 64 Tahun",
          "> 65 Tahun",
        ],
        datasets: [
          {
            label: "Total",
            backgroundColor: "#c42a9d",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
          {
            label: "Laki-laki",
            backgroundColor: "#097CEB",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
          {
            label: "Perempuan",
            backgroundColor: "#e52e6b",
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
        ],
      };
    },
    applyDummy: async function() {
      //console.log(this.formSet);
      let bor = { x: 3.1, y: 6.9 };
      let bto = 8.42;
      let alos = 5.8;
      let toi = 2.6;
      this.scatterData = {
        // labels: ['Standard care', 'Enhanced care', 'Intensive care', 'Discharge planning', 'Telemedicine'],
        datasets: [
          {
            label: "Garis BOR",
            data: [
              { x: 0, y: 0 },
              { x: bor.x, y: bor.y },
            ],
            backgroundColor: "rgba(0,0,0,0)",
            showLine: true,
          },
          {
            label: "Garis BTO",
            data: [
              { x: 0, y: bto },
              { x: bto, y: 0 },
            ],
            backgroundColor: "rgba(0,0,0,0)",
            showLine: true,
          },
          {
            label: "TOI",
            data: [
              { x: toi, y: 0 },
              { x: toi, y: alos },
            ],
            backgroundColor: "rgba(0,0,0,0)",
            showLine: true,
          },
          {
            label: "ALOS",
            data: [
              { x: 0, y: alos },
              { x: toi, y: alos },
            ],
            backgroundColor: "rgba(0,0,0,0)",
            showLine: true,
          },
        ],
      };
    },
    apply: async function() {
      // return;
      this.loaded = false;
      this.errors = [];
      let params = ``;
      let self = this;
      Object.keys(this.formSet).forEach(function(key) {
        if (self.formSet[key]) {
          params += `${key}=${self.formSet[key]}&`;
        } else {
          if (key == "dari") {
            params += `${key}=2012-01-01&`;
          } else if (key == "sampai") {
            params += `${key}=${getInputDate()}&`;
          }
        }
      });
      let colors = ["#097ceb", "#e52e6b", "#16a085"];
      try {
        let result = await this.$store.state.HTTP.get(
          "dashboard/barber_johnson?" + params
        );
        //console.log(result);
        // Get the dates
        let startDate = new Date(this.formSet.dari || "2012-01-01");
        let endDate = new Date(this.formSet.sampai || getInputDate());
        // Calculate the difference in milliseconds
        let diff = endDate - startDate;
        // Convert the difference to days and round up to the nearest whole number
        this.diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
        //console.log(this.diffDays); // 31

        if (result.status == "200" && result.data) {
          //console.log(result.data);
          // result.data.bor *= 10;
          let bor = {
            x: 100 * (10 - parseFloat(result.data.bor / 10)),
            y: 100 * parseFloat(result.data.bor / 10),
          };
          // let bor = {
          //   x: 10 - parseFloat(result.data.bor),
          //   y: parseFloat(result.data.bor),
          // };
          let bto = parseFloat(
            result.data.bto ? this.diffDays / parseFloat(result.data.bto) : 0
          );
          let alos = parseFloat(result.data.alos);
          let toi = parseFloat(result.data.toi);

          // bto /= 100;
          // toi /= 100;
          // alos /= 100;
          // bor *= {x:bor.x*10,y:bor.y*10};
          // alos *= 10;
          //console.log({bor,bto,toi,alos,diffDays:this.diffDays});
          this.scatterData = {
            // labels: ['Standard care', 'Enhanced care', 'Intensive care', 'Discharge planning', 'Telemedicine'],
            datasets: [
              {
                label: "Garis BOR",
                data: [
                  { x: 0, y: 0 },
                  { x: bor.x, y: bor.y },
                ],
                backgroundColor: "rgba(100,100,255,0.1)",
                borderColor: colors[0],
                showLine: true,
              },
              {
                label: "Garis BTO",
                data: [
                  { x: 0, y: bto },
                  { x: bto, y: 0 },
                ],
                backgroundColor: "rgba(255,100,100,0.1)",
                borderColor: colors[1],
                showLine: true,
              },
              {
                label: "TOI",
                data: [
                  { x: toi, y: 0 },
                  { x: toi, y: alos },
                ],
                backgroundColor: "rgba(100,255,100,0.01)",
                borderColor: colors[2],
                showLine: true,
              },
              {
                label: "ALOS",
                data: [
                  { x: 0, y: alos },
                  { x: toi, y: alos },
                ],
                backgroundColor: "rgba(100,255,100,0.01)",
                borderColor: colors[2],
                showLine: true,
              },
            ],
          };
          // this.scatterData = {
          //   labels: ["Barber Johnson"],
          //   datasets: [
          //     {
          //       label: `Bed Occupancy Rate (dalam ${result.data.satuan_bor})`,
          //       backgroundColor: "#e52e6b",
          //       data: [result.data.bor],
          //     },
          //     {
          //       label: `Average Length of Stay (dalam ${result.data.satuan_alos})`,
          //       backgroundColor: "#097ceb",
          //       data: [result.data.alos],
          //     },
          //     {
          //       label: `Turnover Interval (dalam ${result.data.satuan_toi})`,
          //       backgroundColor: "#16a085",
          //       data: [result.data.toi],
          //     },
          //     {
          //       label: `Bed Turnover (dalam ${result.data.satuan_bto})`,
          //       backgroundColor: "#FF6666",
          //       data: [result.data.bto],
          //     },
          //   ],
          // };

          // this.scatterData = result.data.horizontal_bar_chart;

          // let pie_chart = {
          //   labels: result.data.horizontal_bar_chart.labels,
          //   datasets: result.data.horizontal_bar_chart.datasets[0].persentase,
          // };
          // //console.log(result.data.pie_chart);

          // if (pie_chart) {
          //   let pie = pie_chart;
          //   this.pieData = {
          //     labels: pie.labels,
          //     datasets: [
          //       {
          //         label: "",
          //         backgroundColor: ["#097CEB", "#e52e6b"],
          //         data: pie.datasets,
          //       },
          //     ],
          //   };
          // } else {
          //   this.pieData = null;
          // }
          if (result.data.bar_chart) {
            let bar = result.data.bar_chart;
            this.barData = {
              labels: bar.datasets.map((item) => item.label),
              datasets: [
                {
                  label: "Total",
                  backgroundColor: "#c42a9d",
                  data: bar.datasets.map((item) => item.data[0]),
                },
                {
                  label: "Laki-laki",
                  backgroundColor: "#097CEB",
                  data: bar.datasets.map((item) => item.data[1]),
                },
                {
                  label: "Perempuan",
                  backgroundColor: "#e52e6b",
                  data: bar.datasets.map((item) => item.data[2]),
                },
              ],
            };
          } else {
            this.barData = null;
          }

          this.loaded = true;
        } else {
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // await this.displayList();
    // this.applyDummy();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    // this.apply();
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
